import React from 'react';
import { Flex, Image, Text } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { Button } from '@getro/rombo';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import IconHandEmpty from '../../assets/icon-hand-empty.svg';

export const EmptyView = ({ slug }) => (
  <Flex mt="40px" width="100%" height="100%" justifyContent="center">
    <Flex maxWidth="400px" alignItems="center" flexDirection="column" sx={{ gap: '8px' }} textAlign="center">
      <Image flex="0 0 auto" src={IconHandEmpty} width="64px" maxWidth="64px" mb="16px" />
      <Text fontWeight="500" fontSize={1}>
        No lists created yet
      </Text>
      <Text fontSize={1} color="text.subtle" mb="8px">
        Organize your contacts using lists, and optionally share them with companies.{' '}
      </Text>
      <Button as={Link} to={`/networks/${slug}/lists/create`} size="small" icon={Plus}>
        Create list
      </Button>
    </Flex>
  </Flex>
);

EmptyView.propTypes = {
  slug: PropTypes.string.isRequired,
};
